/* In this example, initSwymUI is the main function that loads the Custom Wishlist Page.
   The function is immediately invoked.
*/

(function onPageLoad () {
  if (!window.SwymCallbacks) {
     window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(initSwymUI);
})();

let swat;
let elements;

function initSwymUI(swatInstance) {  
  swat = swatInstance; 
  
  const wishlistElement = document.querySelector('.swymcs-custom-wishlist');

  elements = {
    loader: wishlistElement.querySelector('#swymcs-wishlist-loader'),
    listOptions: wishlistElement.querySelector('#swymcs-wishlist-list-options-container'),
    itemsContainer: wishlistElement.querySelector('#swymcs-wishlist-items-container'),
    emptyContainer: wishlistElement.querySelector('#swymcs-empty-wishlist-container'),
    count: wishlistElement.querySelector('#swymcs-wishlist-count'),
  };

  fetchWishlist();
}

function fetchWishlist() {
  showLoader();
  swat.fetchLists({
    callbackFn: (lists) => {
      lists = lists.reverse(); //Display lists in order of most recent creation
      swat.swymCustomWishlistLists = lists;

      const currentListId = swat.swymCustomWishlistSelectedListId || lists[0]?.lid;
      swat.swymCustomWishlistSelectedListId = currentListId;

      const selectedList = lists.find(({ lid }) => lid === currentListId) || lists[0];

      if (swat.isCollectionsEnabled()) //Render Dropdown with ListNames
        renderMultipleListOptions(lists);
			
      renderList(selectedList.listcontents); //Render the list items
    },
    errorFn: (error) => console.error('Error while fetching all Lists', error),
  });
}

async function renderList(list) {
  elements.itemsContainer.innerHTML = '';
  if (list.length > 0) {
    const wishlistedProducts = await fetchProductData(list);
    _addProducts(wishlistedProducts);
  } 
  updateUIState(list);
}

async function _addProducts(products) { 
  for (let i in products) {
    await fetch(`/products/${products[i].productData.handle}/?section_id=wishlist`)
    .then(response => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      renderProductGrid(html.querySelector('[data-wishlist-item]').querySelector('product-card'), products[i]);
      
      if (i == products.length - 1) {
        // updateUIState(products);
      }
    });
  }
}

function renderProductGrid(html, item) {
  if (html) {
    elements.itemsContainer.appendChild(html);
    html.querySelector('.swymcs-wishlistplus-item-remove')?.addEventListener('click', () => {
      let product = {
        epi: item.epi,
        empi: item.empi,
        du: item.du
      }
      _swat.deleteFromList(_swat.swymCustomWishlistSelectedListId, product, ()=> { 
        html.remove();
        const count = parseInt(elements.count.dataset.swymcsCount) - 1;
        elements.count.dataset.swymcsCount = count;
        elements.count.innerHTML = count;
        if (count == 0) {
          elements.emptyContainer.classList.remove('hidden');
          elements.itemsContainer.classList.add('hidden');
        }
      }, (error) => console.error('Failed to remove from wishlist', error));
    });
  }
}

async function fetchProductData(wishlist) {
  //Fetch Platform Product Data
  const productDataPromises = wishlist.map(async (listItem) => {
    const response = await fetch(`${listItem.du.split('?')[0]}.js`);
    listItem.productData = await response.json();
    return listItem;
  });
  return await Promise.all(productDataPromises);
}

function renderMultipleListOptions(lists) {
  if (lists.length > 1) {
    const listOptionsHtml = lists.map(({ lid, lname, listcontents }) => `
          <option class="swymcs-wishlist-list-option" value="${lid}" ${lid === swat.swymCustomWishlistSelectedListId ? 'selected' : ''}>
            ${lname} (${listcontents.length} items)
          </option>`).join('');
    elements.listOptions.innerHTML = `
          <select class="swymcs-wishlist-list" id="swym-mutliple-list" onchange="onListChange(event)">
            ${listOptionsHtml}
          </select>
        `;
  }
}

function onListChange(event) {
	swat.swymCustomWishlistSelectedListId = event.target.value;
  const selectedList = swat.swymCustomWishlistLists.find(({ lid }) => lid === event.target.value);
  renderList(selectedList.listcontents);
}

function updateUIState(wishlist) {  
  elements.count.innerHTML = wishlist.length;
  elements.count.dataset.swymcsCount = wishlist.length;
  hideLoader();  
  if (wishlist.length > 0) {  
    elements.emptyContainer.classList.add('hidden');  
    elements.itemsContainer.classList.remove('hidden');
  } else {  
    elements.emptyContainer.classList.remove('hidden');
    elements.itemsContainer.classList.add('hidden');
  }
}

function showLoader() {
  elements.loader.classList.remove('hidden');
}

function hideLoader() {
  elements.loader.classList.add('hidden');
}
